module.exports = __webpack_public_path__ + "9f42b987a196e2bd407bb69ab1b50b75.svg";